import styled from '@emotion/styled';
import _ from 'lodash';
import { useCallback, useEffect, useRef, useState } from 'react';
import { ButtonBase } from '../../common';
import { useSideBarClickAway } from '../../common/hooks/useSideBarClickAway';
import { ref as storageRef } from 'firebase/storage';
import {
  BlobProvider,
  PDFDownloadLink,
  PDFViewer,
  StyleSheet,
} from '@react-pdf/renderer';
import CustomerInvoice from './PDFGenerator';
import { INVOICE_REPORT_TYPE, WORKSHEET_REPORT_TYPE } from '..';
import { useDownloadURL, useUploadFile } from 'react-firebase-hooks/storage';
import { useApiService } from '../../context';
import { useToast } from '../../common/hooks/useToast';
import { generate as generateUUID } from 'short-uuid';
import moment from 'moment';
import { TOAST_TYPE } from '../../common/constants';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useTimeout, useToggle } from 'react-use';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useBranding } from 'components/common/hooks/useBranding';
import axios from 'axios';
import {
  DocumentStyles,
  HeaderFooter,
  PageBuilder,
  WorkSheetPageBuilder,
} from './Generators/Invoice';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const StyledDropDownDiv = styled.div`
  // border-width: 0 0 0 2px;
  // border-style: solid;
  // padding-left: 12px;
  // border-color: #6554c0;
  color: #6554c0;
  font-size: 18px;
  .customDropdown {
    width: 100%;
  }
  .customDropdown:not(.p-disabled):hover {
    border-color: #6366f1;
  }

  .customDropdown .p-dropdown-label {
    background: transparent;
    border: 0 none;
    padding: 8px 8px;
    font-size: 12px;
  }

  .customDropdown .p-dropdown-trigger {
    width: 2rem;
  }

  .customDropdown .p-dropdown-trigger-icon {
    font-size: 10px;
  }

  .p-disabled,
  .p-component:disabled {
    opacity: 0.6;
    background-color: #e9ecef;
  }
`;

export const StyledInput = styled.input`
  padding: 8px 8px;
  font-size: 12px;
  width: 100% !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,
    Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  color: #495057;
  background: #ffffff;
  border: 1px solid #ced4da;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s,
    box-shadow 0.2s;
  appearance: none;
  border-radius: 6px;
  margin: 0;

  &:hover {
    border-color: #6366f1;
  }
  &:focus {
    outline: 0 none;
    outline-offset: 0;
    box-shadow: 0 0 0 0.2rem #c7d2fe;
    border-color: #6366f1;
  }
  &:disabled {
    background-color: #e9ecef;
    opacity: 0.6;
    &:hover {
      border-color: #ced4da;
    }
  }
`;

const StyledLabel = styled.label`
  font-size: 12px;
  display: inline-block;
  font-weight: 500;
`;
const StyledH5 = styled.h5`
  // border-width: 0 0 0 2px;
  // border-style: solid;
  // padding-left: 12px;
  // border-color: #6554c0;
  color: #6554c0;
  font-size: 18px;
`;
export const StyledHeaderDiv = styled.div`
  background: ${(props) => props.theme[`primary-100`]};
`;

export const StyledFooterDiv = styled.div`
  background: ${(props) => props.theme[`secondary-light-500`]};
`;
const styles = StyleSheet.create({
  body: {
    // paddingTop: 35,
    // paddingBottom: 65,
    paddingHorizontal: 35,
    height: '100vh',
    width: '100%',
    // borderRadius: '4px',
  },
  title: {
    fontSize: 24,
    textAlign: 'center',
    fontFamily: 'Oswald',
  },
  author: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    fontFamily: 'Oswald',
  },
  text: {
    margin: 12,
    fontSize: 14,
    textAlign: 'justify',
    fontFamily: 'Times-Roman',
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'center',
    color: 'grey',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
});
const PDFContainer = ({
  visibleLeft,
  setVisibleLeft,
  pdfInvoicePayload,
  setPdfInvoicePayload,
}) => {
  const ref = useRef(null);
  const timer = useRef(null);

  const googleUrl = 'http://localhost:3001/reports';

  const [on, toggle] = useToggle(false);
  const [iframSrc, setIframeUrl] = useState(googleUrl);

  const {
    createDoc,
    database,
    rotaPadUser,
    storage,
    rotaPadAccountSettingsTopic,
    setProfileImage,
  } = useApiService();
  const { triggerToast } = useToast();
  const [uploadFile] = useUploadFile();
  const { logo } = useBranding();
  const [companyLogo, setCompanyLogo] = useState(
    'data:image/png;base64,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'
  );
  const { uid, address, bank, email, phone, website, name } =
    rotaPadAccountSettingsTopic ? rotaPadAccountSettingsTopic[`profile`] : {};

  const [userImg] = useDownloadURL(
    storageRef(storage, '/' + uid + '/file.png')
  );
  const [pdfPayload, setPdfPayload] = useState();
  useEffect(() => {
    const fetch = async (imgUrl) => {
      const image = await axios.get(logo.fullLogo, {
        responseType: 'arraybuffer',
      });

      setCompanyLogo(
        'data:image/png;base64,' + Buffer.from(image.data).toString('base64')
      );
      // return
    };
    if (userImg) {
      fetch(userImg);
    }
  }, [userImg]);

  // const docDefinition = {
  //   header: {
  //     columns: [
  //       { text: '', style: 'documentHeaderLeft' },
  //       { text: '', style: 'documentHeaderCenter' },
  //       { text: '', style: 'documentHeaderRight' },
  //     ],
  //   },
  //   footer: {
  //     columns: [
  //       { text: '', style: 'documentFooterLeft' },
  //       {
  //         text: `${name}
  //       ${address} Email: ${email}; Tel: ${phone}; Website: ${website}`,
  //         style: 'documentFooterCenter',
  //       },
  //       { text: '', style: 'documentFooterRight' },
  //     ],
  //   },
  //   content: [
  //     // Header

  //     {
  //       columns: [
  //         [
  //           {
  //             image: companyLogo,
  //             width: 100,
  //           },
  //           {
  //             text: 'XynexCare Limited',
  //             style: 'comapnyTitle',
  //           },
  //         ],
  //       ],
  //     },
  //     '\n',
  //     {
  //       text: 'Weekly Timesheet',
  //       style: 'header',
  //       fontSize: 18,
  //       bold: true,
  //       margin: [10, 0, 0, 10],
  //       alignment: 'center',
  //     },
  //     '\n',
  //     {
  //       margin: [0, 0, 0, 10],
  //       layout: {
  //         fillColor: function (rowIndex, node, columnIndex) {
  //           return rowIndex % 2 === 0 ? '#f5f5f5' : '#f5f5f5';
  //         },
  //       },
  //       table: {
  //         widths: ['*', '*'],
  //         heights: [10],
  //         body: [
  //           [
  //             {
  //               text: 'Week Ending',
  //               fontSize: 9,
  //               bold: true,
  //             },
  //             {
  //               text: '',
  //               fontSize: 9,
  //               bold: true,
  //             },
  //           ],
  //         ],
  //       },
  //     },
  //     {
  //       margin: [0, 0, 0, 10],
  //       layout: {
  //         fillColor: function (rowIndex, node, columnIndex) {
  //           return rowIndex % 2 === 0 ? '#f5f5f5' : '#f5f5f5';
  //         },
  //       },
  //       table: {
  //         widths: ['*', '*'],
  //         heights: [10],
  //         body: [
  //           [
  //             {
  //               text: 'Employee name:',
  //               fontSize: 9,
  //               bold: true,
  //             },
  //             {
  //               text: 'Client Name:',
  //               fontSize: 9,
  //               bold: true,
  //             },
  //           ],
  //           [
  //             {
  //               text: 'Title:',
  //               fontSize: 9,
  //               bold: true,
  //             },
  //             {
  //               text: 'Client Address:',
  //               fontSize: 9,
  //               bold: true,
  //             },
  //           ],
  //         ],
  //       },
  //     },
  //     // '\n',
  //     // Items
  //     {
  //       table: {
  //         // headers are automatically repeated if the table spans over multiple pages
  //         // you can declare how many rows should be treated as headers
  //         headerRows: 1,
  //         widths: [
  //           'auto',
  //           'auto',
  //           'auto',
  //           'auto',
  //           'auto',
  //           'auto',
  //           60,
  //           '*',
  //           // 'auto',
  //           '*',
  //         ],
  //         // heights: [5],

  //         body: [
  //           // Table Header
  //           [
  //             {
  //               text: 'Day',
  //               style: 'tableItemsHeader',
  //             },
  //             {
  //               text: 'Date',
  //               style: 'tableItemsHeader',
  //             },
  //             {
  //               text: 'Start Time',
  //               style: 'tableItemsHeader',
  //             },
  //             {
  //               text: 'Lunch',
  //               style: 'tableItemsHeader',
  //             },
  //             {
  //               text: 'End Time',
  //               style: 'tableItemsHeader',
  //             },
  //             {
  //               text: 'Hours',
  //               style: 'tableItemsHeader',
  //             },
  //             {
  //               text: 'Shift Type',
  //               style: 'tableItemsHeader',
  //             },
  //             {
  //               text: 'Staff Name',
  //               style: 'tableItemsHeader',
  //             },
  //             {
  //               text: 'Signature',
  //               style: 'tableItemsHeader',
  //             },
  //           ],
  //           // Items
  //           // Item 1
  //           [
  //             {
  //               text: '1ggg',
  //               style: 'itemsHeader',
  //             },
  //             {
  //               text: 'Item 1',
  //               style: 'itemsHeader',
  //             },
  //             {
  //               text: '1',
  //               style: 'itemsHeader',
  //             },
  //             {
  //               text: '1ggg',
  //               style: 'itemsHeader',
  //             },
  //             {
  //               text: '1ggg',
  //               style: 'itemsHeader',
  //             },
  //             {
  //               text: '$999.99',
  //               style: 'itemsHeader',
  //             },
  //             {
  //               text: '0%',
  //               style: 'itemsHeader',
  //             },
  //             {
  //               text: '0%',
  //               style: 'itemsHeader',
  //             },
  //             {
  //               text: '$999.99',
  //               style: 'itemsHeader',
  //             },
  //           ],
  //           // Item 2
  //           [
  //             {
  //               text: '1ggg',
  //               style: 'itemsHeader',
  //             },
  //             {
  //               text: 'Item 1',
  //               style: 'itemsHeader',
  //             },
  //             {
  //               text: '1',
  //               style: 'itemsHeader',
  //             },
  //             {
  //               text: '1ggg',
  //               style: 'itemsHeader',
  //             },
  //             {
  //               text: '1ggg',
  //               style: 'itemsHeader',
  //             },
  //             {
  //               text: '$999.99',
  //               style: 'itemsHeader',
  //             },
  //             {
  //               text: '0%',
  //               style: 'itemsHeader',
  //             },
  //             {
  //               text: '0%',
  //               style: 'itemsHeader',
  //             },
  //             {
  //               text: '0%',
  //               style: 'itemsHeader',
  //             },
  //           ],

  //           [
  //             {
  //               text: 'WEEKLY TOTALS (Hours worked)',
  //               colSpan: 5,
  //               bold: true,
  //               fontSize: 9,
  //               // color: 'red',
  //             },
  //             {},
  //             {},
  //             {},
  //             {},
  //             {
  //               text: '',
  //               colSpan: 4,
  //               bold: true,
  //               fontSize: 10,
  //               color: 'red',
  //               border: [false, false, true, false],
  //             },
  //             {},
  //             {},
  //             {},
  //           ],

  //           [
  //             {
  //               text: 'WEEKLY TOTALS (Sleeps)',
  //               colSpan: 5,
  //               bold: true,
  //               fontSize: 9,
  //               // color: 'red',
  //             },
  //             {},
  //             {},
  //             {},
  //             {},
  //             {
  //               text: '',
  //               colSpan: 4,
  //               bold: true,
  //               fontSize: 10,
  //               color: 'red',
  //               border: [false, false, true, true],
  //             },
  //             {},
  //             {},
  //             {},
  //           ],
  //           // END Items
  //         ],
  //       }, // table
  //       //  layout: 'lightHorizontalLines'
  //     },
  //     '\n',
  //     {
  //       margin: [0, 0, 0, 10],
  //       layout: {
  //         fillColor: function (rowIndex, node, columnIndex) {
  //           return rowIndex % 2 === 0 ? '#f5f5f5' : '#f5f5f5';
  //         },
  //       },
  //       table: {
  //         widths: ['*', '*', '*', '*', '*', '*', '*', '*'],
  //         heights: [10],
  //         body: [
  //           [
  //             {
  //               text: '1:1',
  //               fontSize: 8,
  //               bold: true,
  //             },
  //             {
  //               text: '',
  //               fontSize: 8,
  //               bold: true,
  //             },
  //             {
  //               text: 'Care',
  //               fontSize: 8,
  //               bold: true,
  //             },
  //             {
  //               text: '',
  //               fontSize: 8,
  //               bold: true,
  //             },
  //             {
  //               text: 'Support work',
  //               fontSize: 8,
  //               bold: true,
  //             },
  //             {
  //               text: '',
  //               fontSize: 8,
  //               bold: true,
  //             },
  //             {
  //               text: 'Nurse',
  //               fontSize: 8,
  //               bold: true,
  //             },
  //             {
  //               text: '',
  //               fontSize: 8,
  //               bold: true,
  //             },
  //           ],
  //         ],
  //       },
  //     },

  //     // '\n',
  //     {
  //       margin: [0, 0, 0, 10],
  //       layout: {
  //         fillColor: function (rowIndex, node, columnIndex) {
  //           return rowIndex % 2 === 0 ? '#f5f5f5' : '#f5f5f5';
  //         },
  //       },
  //       table: {
  //         widths: ['*', '*'],
  //         heights: [10],
  //         body: [
  //           [
  //             {
  //               text: 'Employee signature: ',
  //               fontSize: 9,
  //               bold: true,
  //             },
  //             {
  //               text: 'Date:',
  //               fontSize: 9,
  //               bold: true,
  //             },
  //           ],
  //         ],
  //       },
  //     },
  //     {
  //       text: 'TO BE COMPLETED BY CLIENT',
  //       style: 'header',
  //       fontSize: 11,
  //       bold: true,
  //       margin: [0, 0, 0, 0],
  //       alignment: 'left',
  //     },
  //     {
  //       margin: [0, 0, 0, 4],
  //       layout: {
  //         fillColor: function (rowIndex, node, columnIndex) {
  //           return rowIndex % 2 === 0 ? '#f5f5f5' : '#f5f5f5';
  //         },
  //       },
  //       table: {
  //         widths: ['*', '*'],
  //         heights: [10],
  //         body: [
  //           [
  //             {
  //               text: 'Staff name:',
  //               fontSize: 9,
  //               bold: true,
  //             },
  //             {
  //               text: 'Signature:',
  //               fontSize: 9,
  //               bold: true,
  //             },
  //           ],
  //           [
  //             {
  //               text: 'Position:',
  //               fontSize: 9,
  //               bold: true,
  //             },
  //             {
  //               text: 'Date:',
  //               fontSize: 9,
  //               bold: true,
  //             },
  //           ],
  //         ],
  //       },
  //     },
  //     {
  //       text: 'We certify that the above mentioned staff worker was present to cover the stated times and to our satisfaction. We agree to be bound by the employment business Terms & Condition.',
  //       style: 'header',
  //       fontSize: 7,
  //       bold: true,
  //       margin: [0, 0, 0, 0],
  //       alignment: 'left',
  //     },
  //     {
  //       text: 'Note:',
  //       style: 'header',
  //       fontSize: 10,
  //       bold: true,
  //       margin: [0, 20, 0, 0],
  //       alignment: 'left',
  //     },
  //     {
  //       text: '* Please email fully signed and completed timesheet to: timesheet@xynexcare.com',
  //       style: 'header',
  //       fontSize: 8,
  //       bold: true,
  //       margin: [0, 0, 0, 10],
  //       alignment: 'left',
  //     },
  //   ],
  //   styles: {
  //     // Document Header
  //     documentHeaderLeft: {
  //       fontSize: 10,
  //       margin: [5, 5, 5, 5],
  //       alignment: 'left',
  //     },
  //     documentHeaderCenter: {
  //       fontSize: 10,
  //       margin: [5, 5, 5, 5],
  //       alignment: 'center',
  //     },
  //     documentHeaderRight: {
  //       fontSize: 10,
  //       margin: [5, 5, 5, 5],
  //       alignment: 'right',
  //     },
  //     // Document Footer
  //     documentFooterLeft: {
  //       fontSize: 10,
  //       margin: [15, 15, 15, 15],
  //       alignment: 'left',
  //     },
  //     documentFooterCenter: {
  //       fontSize: 8,
  //       // margin: [0, 0, 0, 0],
  //       alignment: 'center',
  //     },
  //     documentFooterRight: {
  //       fontSize: 10,
  //       margin: [5, 5, 5, 5],
  //       alignment: 'right',
  //     },
  //     // Invoice Title
  //     invoiceTitle: {
  //       fontSize: 22,
  //       bold: true,
  //       alignment: 'right',
  //       margin: [0, 0, 0, 15],
  //     },

  //     customerBillingToTitle: {
  //       fontSize: 12,
  //       bold: true,
  //       alignment: 'right',
  //       margin: [0, 20, 0, 5],
  //     },
  //     customerBillingToValue: {
  //       fontSize: 12,
  //       // bold: true,
  //       alignment: 'right',
  //       // margin: [0, 20, 0, 5],
  //     },
  //     // Invoice Details
  //     invoiceSubTitle: {
  //       fontSize: 12,
  //       alignment: 'right',
  //     },
  //     invoiceSubValue: {
  //       fontSize: 12,
  //       alignment: 'right',
  //     },
  //     // Billing Headers
  //     invoiceBillingTitle: {
  //       fontSize: 12,
  //       bold: true,
  //       alignment: 'left',
  //       margin: [0, 20, 0, 5],
  //     },
  //     comapnyTitle: {
  //       fontSize: 12,
  //       bold: true,
  //       alignment: 'left',
  //       // margin: [0, 20, 0, 5],
  //     },
  //     // Billing Details
  //     invoiceBillingDetails: {
  //       alignment: 'left',
  //     },
  //     invoiceBillingAddressTitle: {
  //       margin: [0, 7, 0, 3],
  //       bold: true,
  //     },
  //     invoiceBillingAddress: {},
  //     // Items Header
  //     itemsHeader: {
  //       margin: [0, 5, 0, 5],
  //       bold: true,
  //       fontSize: 8,
  //     },
  //     itemsTotals: {
  //       margin: [0, 5, 0, 5],
  //       bold: true,
  //       fontSize: 9,
  //       color: 'red',
  //     },
  //     // Item Title
  //     itemTitle: {
  //       bold: true,
  //     },
  //     itemSubTitle: {
  //       italics: true,
  //       fontSize: 11,
  //     },
  //     itemNumber: {
  //       margin: [0, 5, 0, 5],
  //       alignment: 'center',
  //     },
  //     itemTotal: {
  //       margin: [0, 5, 0, 5],
  //       bold: true,
  //       alignment: 'center',
  //     },

  //     // Items Footer (Subtotal, Total, Tax, etc)
  //     itemsFooterSubTitle: {
  //       margin: [0, 5, 0, 5],
  //       bold: true,
  //       alignment: 'right',
  //     },
  //     itemsFooterSubValue: {
  //       margin: [0, 5, 0, 5],
  //       bold: true,
  //       alignment: 'center',
  //     },
  //     itemsFooterTotalTitle: {
  //       margin: [0, 5, 0, 5],
  //       bold: true,
  //       alignment: 'right',
  //     },
  //     itemsFooterTotalValue: {
  //       margin: [0, 5, 0, 5],
  //       bold: true,
  //       alignment: 'center',
  //     },
  //     signaturePlaceholder: {
  //       margin: [0, 70, 0, 0],
  //     },
  //     signatureName: {
  //       bold: true,
  //       alignment: 'center',
  //     },
  //     signatureJobTitle: {
  //       italics: true,
  //       fontSize: 10,
  //       alignment: 'center',
  //     },
  //     notesTitle: {
  //       fontSize: 10,
  //       bold: true,
  //       margin: [0, 50, 0, 3],
  //     },
  //     notesText: {
  //       fontSize: 10,
  //     },
  //     center: {
  //       alignment: 'center',
  //     },
  //   },
  //   defaultStyle: {
  //     columnGap: 20,
  //     // font: 'arial',
  //   },
  // };
  useEffect(() => {
    // console.log('DDDDDDDDDDDDDDDDDD ==== ', moment().format('dddd'));
    if (
      !_.isEmpty(pdfInvoicePayload) &&
      !_.isEmpty(rotaPadAccountSettingsTopic)
    ) {
      // start();
      const { uid, address, bank, email, phone, website, name } =
        rotaPadAccountSettingsTopic[`profile`];
      let getMakePdfPayload = {};
      if (pdfInvoicePayload.reportType === INVOICE_REPORT_TYPE) {
        const {
          customer: {
            name: customerName,
            address: customerAddress,
            customerId,
            units,
            payRate,
            sleepRate,
          },
          computedShifts,
          date,
        } = pdfInvoicePayload;

        // console.log('units ==== ', units);
        // setPdfPayload
        getMakePdfPayload = {
          ...HeaderFooter({ address, email, name, phone, website }),
          ...DocumentStyles(),
          content: PageBuilder({
            companyLogo,
            address,
            bank,

            name,
            customerName,
            customerAddress,
            customerId,
            units,
            computedShifts,
            payRate,
            sleepRate,
            date,
          }),
        };
      } else if (pdfInvoicePayload.reportType === WORKSHEET_REPORT_TYPE) {
        // getMakePdfPayload = docDefinition;
        // console.log('pdfInvoicePayload ===== ', pdfInvoicePayload);
        const {
          teamMembers,
          computedShifts,
          date,
          unitPrintName: unitName,
          unitPrintAddress: unitAddress,
        } = pdfInvoicePayload;
        getMakePdfPayload = {
          ...HeaderFooter({ address, email, name, phone, website }),
          ...DocumentStyles(),
          content: WorkSheetPageBuilder({
            teamMembers,
            companyLogo,
            unitName,
            unitAddress,
            date,
            computedShifts,
          }),
        };
      }

      const pdfGenerator = pdfMake.createPdf(getMakePdfPayload);

      pdfGenerator.getDataUrl((blob) => {
        // console.log(blob);

        setIframeUrl(blob);
        setPdfPayload(getMakePdfPayload);
        timer.current = setTimeout(() => {
          toggle(true); // count is 0 here
        }, 2000);
      });
    }

    return () => {
      toggle(false);
      setIframeUrl(null);
      clearInterval(timer.current);
    };
  }, [
    pdfInvoicePayload,
    visibleLeft,
    companyLogo,
    rotaPadAccountSettingsTopic,
  ]);
  useSideBarClickAway({
    ref,
    setVisibleLeft: () => setVisibleLeft(false),
    setNewGroup: () => console.log('setNewGroup'),
  });

  const saveReport = useCallback(() => {
    const pdfGenerator = pdfMake.createPdf(pdfPayload);
    pdfGenerator.getBlob(async (blob) => {
      // console.log('pdfInvoicePayload ===== ', pdfInvoicePayload);
      // console.log(blob);
      if (rotaPadUser) {
        const uuid = generateUUID();
        const ref = storageRef(storage, '/' + uuid + '/' + uuid + '.pdf');
        await uploadFile(ref, blob, {
          contentType: blob.type,
        });

        // const getUrl = await fetchProfileImageData({
        //   path: '/' + uuid + '/file.pdf',
        // });

        const success = await createDoc(
          database,
          `printer/${uuid}`,
          {
            uid: uuid,
            filename: uuid + '.pdf',
            type: pdfInvoicePayload.reportType || 'NA',
            createdAt: moment().format(),
          }
          // setRotaPadUser
        );

        if (success) {
          triggerToast({
            message: 'Report details saved successfully!',
            type: TOAST_TYPE.success,
          });
        } else {
          triggerToast({
            message: 'Report details could not be saved!',
            type: TOAST_TYPE.warning,
          });
        }
      }
    });
  }, [rotaPadUser, pdfPayload, pdfInvoicePayload]);

  if (_.isEmpty(pdfInvoicePayload)) return;

  // console.log('pdfInvoicePayload ===== ', pdfInvoicePayload);

  return (
    <div
      ref={ref}
      className={`offcanvas offcanvas-end  ${
        visibleLeft ? 'show shadow-lg' : 'hiding'
      }`}
      // tabIndex='-1'
      id='offcanvasExample'
      aria-labelledby='offcanvasExampleLabel'
      style={{ width: '50%', zIndex: 555 }}
    >
      <StyledHeaderDiv className='offcanvas-header'>
        <h5
          className='offcanvas-title'
          style={{ lineHeight: '27px' }}
        >
          {pdfInvoicePayload.reportType === INVOICE_REPORT_TYPE && (
            <>Customer Invoice</>
          )}
          {pdfInvoicePayload.reportType === WORKSHEET_REPORT_TYPE && (
            <>Team Member Worksheet</>
          )}
        </h5>
        <button
          type='button'
          className='btn-close'
          data-bs-dismiss='offcanvas'
          aria-label='Close'
          onClick={() => {
            setVisibleLeft(false);
            setPdfInvoicePayload();
          }}
        ></button>
      </StyledHeaderDiv>
      <div
        style={{
          maxHeight: 'calc(100vh - 118px)',
          overflow: 'auto',
        }}
      >
        <div className='offcanvas-body p-0'>
          <div
            className='d-flex flex-column mb-0'
            style={{ height: '100vh' }}
          >
            {on ? (
              <iframe
                title='myBook'
                src={iframSrc}
                height='100%'
                width='100%'
                // frameBorder='0'
                // scrolling='no'
                // allowFullScreen={true}
                // ref={refIframe}
              ></iframe>
            ) : (
              <ProgressSpinner
                style={{ width: '50px', height: '50px' }}
                strokeWidth='8'
                fill='var(--surface-ground)'
                animationDuration='.5s'
                className='position-absolute top-50 start-50 translate-middle'
              />
            )}

            {/* <div>
              <BlobProvider
                document={
                  <CustomerInvoice
                    customers={[]}
                    payload={pdfInvoicePayload}
                    // reportType='Invoice'
                  />
                }
              >
                {({ blob, url, loading, error }) => {
                  // console.log('rotaPadUser ==== ', rotaPadUser);
                  return loading ? (
                    'Loading document...'
                  ) : (
                    <ButtonBase
                      variant='outline'
                      size='small'
                      onClick={async () => {
                        // const [uploadFile] = useUploadFile();

                        if (rotaPadUser) {
                          const uuid = generateUUID();
                          const ref = storageRef(
                            storage,
                            '/' + uuid + '/' + uuid + '.pdf'
                          );
                          await uploadFile(ref, blob, {
                            contentType: blob.type,
                          });

                          // const getUrl = await fetchProfileImageData({
                          //   path: '/' + uuid + '/file.pdf',
                          // });

                          const success = await createDoc(
                            database,
                            `printer/${uuid}`,
                            {
                              uid: uuid,
                              filename: uuid + '.pdf',
                              type: pdfInvoicePayload.reportType,
                              createdAt: moment().format(),
                            }
                            // setRotaPadUser
                          );

                          if (success) {
                            triggerToast({
                              message: 'Report details saved successfully!',
                              type: TOAST_TYPE.success,
                            });
                          } else {
                            triggerToast({
                              message: 'Report details could not be saved!',
                              type: TOAST_TYPE.warning,
                            });
                          }
                        }

                        // console.log('getUrl ==== ', getUrl);
                      }}
                    >
                      Save report
                    </ButtonBase>
                  );
                }}
              </BlobProvider>
            </div>
            <PDFViewer
              style={styles.body}
              showToolbar={true}
            >
              <CustomerInvoice
                customers={[]}
                payload={pdfInvoicePayload}
                // reportType='Invoice'
              />
            </PDFViewer> */}
          </div>
        </div>
      </div>

      <StyledFooterDiv className='offcanvas-header'>
        <div className='btn-toolbar my-2 my-sm-0 my-md-0'>
          <div className='d-flex flex-row mb-0'>
            <div className='me-2'>
              <ButtonBase
                type='button'
                variant='primary'
                size='small'
                onClick={() => {
                  setVisibleLeft(false);
                }}
                disabled={false}
              >
                Close
              </ButtonBase>
            </div>
            <div>
              <ButtonBase
                type='button'
                variant='primary'
                size='small'
                onClick={saveReport}
                disabled={false}
              >
                Save Report
              </ButtonBase>
            </div>
          </div>
        </div>
      </StyledFooterDiv>
    </div>
  );
};

export default PDFContainer;
